import { Phone } from 'lucide-react';

export default function FloatingCallButton() {
  return (
    <a
      href="tel:9183210654"
      className="fixed bottom-6 right-6 z-50 lg:hidden flex items-center gap-2 bg-[#dc2626] hover:bg-[#b91c1c] text-white px-5 py-4 rounded-full shadow-lg floating-call-btn btn-press transition-all"
      aria-label="Call Junk Removal M.D."
      data-testid="floating-call-btn"
    >
      <div className="relative">
        <Phone className="w-6 h-6" />
        <span className="absolute -top-1 -right-1 w-3 h-3 bg-white rounded-full animate-pulse-ring" />
      </div>
      <span className="font-bold uppercase tracking-wide text-sm">Call Now</span>
    </a>
  );
}
